import useSWR, { SWRResponse } from "swr";
import { IRiskLevelProposal } from "../../../types/robot/IRiskLevelProposal";
import { IRiskLevel } from "../../../types/robot/IRiskLevel";
import { IUseRiskLevel } from "./types";
import commonSwrConfig from "@portal/hooks/commonSwrConfig";
import useCenterId from "@portal/hooks/useCenterId";
import { useSession } from "@portal/auth/client/SessionProvider";

const useRiskLevelProposal: IUseRiskLevel = (request: IRiskLevel) => {
  const centerId = useCenterId();
  const { update } = useSession();

  const path = `/api/robot/RiskLevelProposal?centerId=${centerId}`;

  const fetcher = (url: URL) =>
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...request, centerId }),
    }).then(res => res.json());

  const { data, error }: SWRResponse<IRiskLevelProposal[], unknown> = useSWR(path, fetcher, commonSwrConfig(update));
  const response = { data, error, isLoading: !data && !error };

  return response;
};

export default useRiskLevelProposal;
